import { firefuncs } from "config/firebase";
import { httpsCallable } from "firebase/functions";

export const getMessages = async (
  pageNum: number,
  userId: string,
): Promise<any> => {
  const getMsgs = httpsCallable(firefuncs, "getInboxMessages");
  return getMsgs({
    pageNum,
    userId,
  })
    .then((res) => res)
    .catch((err) => err);
};

export default {
  getMessages,
};
